import React from 'react'

const Icon3Dots = ({size = 30}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="5 5 32 32"
    >
      <g fill="#fff" fillRule="evenodd" transform="translate(9 9)">
        <circle cx="12.5" cy="2.5" r="2.5" />
        <circle cx="12.5" cy="21.5" r="2.5" />
        <circle cx="12.5" cy="12.5" r="2.5" />
      </g>
    </svg>
  )
}

export default Icon3Dots
